<!-- 文件: CountToWrapper.vue -->
<template>
  <div class="count-to-wrapper" ref="countWrapper">
    <count-to
      v-if="inView"
      ref="countTo"
      :start-val="startValue"
      :end-val="numericEndValue"
      :duration="duration"
      :decimals="processedDecimals"
      :separator="separator"
      :prefix="prefix"
      :suffix="suffix"
      :use-easing="useEasing"
      @counting="handleCounting"
      @finished="handleFinished">
    </count-to>
    <span>{{ nonNumericSuffix }}</span>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  components: {
    CountTo
  },
  props: {
    startValue: {
      type: [Number, String],
      default: 0
    },
    endValue: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      default: 2000
    },
    decimals: {
      type: Number,
      default: 0
    },
    autoDecimals: {
      type: Boolean,
      default: false
    },
    separator: {
      type: String,
      default: ','
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    useEasing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inView: false,
      nonNumericSuffix: ""
    };
  },
  computed: {
    // 提取字符串中的数字部分
    numericEndValue() {
      const numericPart = this.endValue.replace(/[^\d.-]/g, '');
      return this.parseNumber(numericPart);
    },
    // 自动计算小数位数
    processedDecimals() {
      if (!this.autoDecimals) {
        return this.decimals;
      }
      const match = /\.(\d+)/.exec(this.numericEndValue.toString());
      return match ? match[1].length : 0;
    }
  },
  mounted() {
    this.initValue();
    this.createObserver();
  },
  methods: {
    initValue() {
      // 提取非数字后缀
      const match = this.endValue.match(/[^\d.-]+$/);
      if (match) {
        this.nonNumericSuffix = match[0];
      }
    },
    parseNumber(value) {
      return isNaN(value) ? 0 : parseFloat(value);
    },
    handleCounting(data) {
      this.$emit('counting', data);
    },
    handleFinished() {
      this.$emit('finished');
    },
    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView = true;
            observer.unobserve(entry.target); // 进入视口后取消监听，防止重复触发
          }
        });
      });

      observer.observe(this.$refs.countWrapper);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
